module.exports = __webpack_public_path__ + "static/media/Shaw.2e5c92e7.svg";